import React from "react";
import PropTypes from "prop-types";

class FilterAndSortBar extends React.Component {
  constructor(props) {
    super(props);
    this._onFilterClick = this._onFilterClick.bind(this);
    this._onSortClick = this._onSortClick.bind(this);
  }

  _onFilterClick(e) {
    e.preventDefault();
    this.props.onFilterClick(e);
  }

  _onSortClick(e) {
    e.preventDefault();
    this.props.onSortClick(e);
  }

  renderFilter() {
    if (this.props.onFilterClick) {
      return (
        <li>
          <button
            className="filter-and-sort-button filter-button"
            aria-expanded="false"
            onClick={this._onFilterClick}
            onTouchEnd={this._onFilterClick}
          >
            {i18n.t("base.filter")}
          </button>
          {this.props.filterMenu}
        </li>
      );
    }
  }

  renderSort() {
    if (this.props.onSortClick) {
      return (
        <li>
          <button
            className="filter-and-sort-button sort-button"
            aria-expanded="false"
            onClick={this._onSortClick}
            onTouchEnd={this._onSortClick}
          >
            {i18n.t("base.sort")}
          </button>
          {this.props.sortMenu}
        </li>
      );
    }
  }

  render() {
    return (
      <ul className="filter-and-sort-bar noselect" id={this.props.id}>
        {this.renderFilter()}
        {this.renderSort()}
      </ul>
    );
  }
}

FilterAndSortBar.propTypes = {
  id: PropTypes.string,
  onFilterClick: PropTypes.func,
  onSortClick: PropTypes.func,
  filterMenu: PropTypes.element,
  sortMenu: PropTypes.element
};

FilterAndSortBar.defaultProps = {
  id: ""
};

module.exports = FilterAndSortBar;
